export const pathWithoutQueryOrAnchor = (path: string) => {
  return path.split(/[?#]/)[0]; // split by either ? or #
};

export const getQuerySegmentFromPath = (path: string) =>
  path.split('?')[1] ? `?${path.split('?')[1]}` : '';
